
import "./SignIn.css";
import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { handleLogin } from "../../api";
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import RemoveRedEyeIcon from '@mui/icons-material/RemoveRedEye';

function SignIn() {

    const [wrongPassMessage, setWrongPassMessage] = useState<boolean>(false);
    const [showPass, setShowPass] = useState<boolean>(false);
    const [emailInp, setEmailInp] = useState<string>("");
    const [passInp, setPassInp] = useState<string>("");
    const [activeBtn, setActiveBtn] = useState<boolean>(false);
    const navigate = useNavigate();

    useEffect(() => {
        if (emailInp && passInp) {
            setActiveBtn(true);
        }
    }, [emailInp, passInp])

    const loginRequest = async () => {
        let formData: FormData = new FormData();
        formData.append("username", emailInp);
        formData.append("password", passInp);
        try {
            const loginData = await handleLogin(formData);
            if (loginData) {
                localStorage.setItem('tkn', loginData.data.token);
                localStorage.setItem('reftkn', loginData.data.refreshToken);
                localStorage.setItem("roles", JSON.stringify(loginData.data.roles));
                localStorage.setItem("clientId", loginData.data.id)
                navigate("/main");
                window.location.reload();
            }
            else {
                setWrongPassMessage(true);
            }
        }
        catch (err) {
            console.log(err);
        }
    }

    document.body.onkeydown = async (e: KeyboardEvent) => {
        if (e.key === "Enter") {
            await loginRequest();
        }
    }

    return(
        <div className = "signIn-container">
            <div className = "signIn-box">
                <div className = "signin-header">
                    <h2>Sign In</h2>
                </div>
                <div className = "signIn-form">
                    <div className = "signIn-form-block">
                        <label htmlFor = "signInEmail">Email</label>
                        <input
                            type = "email"
                            name = "signInEmail"
                            id = "signInEmail"
                            value = { emailInp }
                            onChange = {(e) => {
                                setEmailInp(e.target.value)
                            }}
                        />
                    </div>
                    <div className = "signIn-form-block">
                        <label htmlFor = "signInFormPass">Password</label>
                        <div id = "signInFormPass">
                            <input
                                type = { !showPass ? "password" : "text" }
                                id = "signInPass"
                                value = { passInp }
                                onChange = {(e) => {
                                    setPassInp(e.target.value);
                                }}
                            />
                            {
                                showPass ?
                                    <VisibilityOffIcon
                                        className = "showPass"
                                        onClick = {() => setShowPass(false)}
                                    />
                                    :
                                    <RemoveRedEyeIcon
                                        className = "hidePass"
                                        onClick = { () => setShowPass(true) }
                                    />
                            }
                        </div>
                        <div className = "signInAlert">
                            <span id = "wrongPassMessage" style = {{ display: wrongPassMessage ? "block" : "none" }}>Wrong Email or Password</span>
                        </div>
                    </div>
                    <div className = "signInBtn">
                        <button
                            style = {{
                                backgroundColor: activeBtn ? "#004DE7" : "transparent",
                                color: !activeBtn ? "#004DE7" : "white",
                                cursor: activeBtn ? "pointer" : "not-allowed"
                            }}
                            onClick = { loginRequest }
                        >
                            Sign In
                        </button>
                    </div>
                    <div className = "signIn-forgetPass">
                    </div>
                </div>
            </div>
        </div>
    )
}

export default SignIn;
